<template>
    <div>
        <v-dialog v-model="bankDialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-toolbar
                color="primary"
                class="toolbar--wraped mb-3"
                dark
                flat
            >
                  <v-toolbar-title>Account Information</v-toolbar-title>
                  <v-spacer />
                  <v-btn
                    icon
                    color="white"
                    @click="bankDialog = false"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
            </v-toolbar>
            <v-col>
                <v-row class="align-content-center">
                  <v-col class="pa-0 px-3 pt-3 pa-lg-3">
                    <v-select
                      v-model="bank"
                      :items="filteredBanks"
                      :item-text="'Name'"
                      return-object
                      label="Bank"
                      name="bank"
                      color="primary"
                      outlined
                      :error-messages="errors.first('bank')"
                      v-validate="'required'"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row
                    v-if="allowBranches && branches.length"
                    class="align-content-center"
                >
                  <v-col class="pa-0 pt-3 pa-lg-3">
                    <v-select
                      v-model="branch"
                      :items="branches"
                      :item-text="'BranchName'"
                      return-object
                      label="Branch"
                      name="branch"
                      color="primary"
                      outlined
                      :error-messages="errors.first('branch')"
                      v-validate="'required'"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row class="align-content-center">
                    <v-col class="pa-0 pt-3 pa-lg-3">
                        <v-btn
                            color="primary"
                            text
                            @click="proceed"
                        >
                            Continue
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-dialog>
        <v-btn
            color="primary"
            text
            @click="init"
        >
            <slot></slot>
        </v-btn>
    </div>
</template>

<script>
import MonoService from '../../services/MonoService';
import FlutterwaveService from '../../services/FlutterwaveService';

export default {
    props: {
        country: String,
        allowBranches: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            bankDialog: false,
            banks: [],
            bank: null,
            branches: [],
            branch: null,
            branch_code: null,
        };
    },
    mounted() {
        if (!this.country) {
          return;
        }

        this.loadBanks(this.country);
    },
    watch: {
      bank: function(bank) {
          if (this.allowBranches && bank && bank.Id) {
              this.loadBranches(bank.Id);
          }
      },
      country: function(country) {
          if (country) {
              this.loadBanks(country);
          }
      },
    },
    computed: {
        filteredBanks() {
            const banks = this.banks.filter((bank) => !bank.IsMobileVerified);
            return banks;
        },
    },
    methods: {
        init() {
            if (this.country === 'NG') {
                return this.openHandler();
            }

            this.bank = null;
            this.branch = null;
            this.bankDialog = true;
        },
        validate() {
            if (this.country === 'NG') {
                return true;
            }

            if (!this.bank) {
                return false;
            }

            if (this.allowBranches && this.branches.length) {
                if (!this.branch) {
                    return false;
                }
            }

            return true;
        },
        proceed() {
          if (!this.validate()) {
              return;
          }

          this.bankDialog = false;
          this.openHandler();
        },
        async openHandler() {
            const vm = this;
            const countryCode = this.$store.state.user.country_abbreviation;
            try {
                const connect = await MonoService.getConnect({
                    onSuccess: (data) => {
                      vm.$emit('onFinished', {
                          ...data,
                          provider: 'MONO',
                          bank: this.bank,
                          branch: this.branch,
                      });
                    },
                }, countryCode);

                connect.setup();
                connect.open();
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error loading Mono script',
                    text: err,
                });
            }
        },
        loadBanks(abbreviation) {
            this.$emit('loading');
            return FlutterwaveService.getBanksByCountry(abbreviation)
                .then((banks) => {
                    if (banks.length === 0) {
                        this.$swal({
                            type: 'error',
                            title: 'No banks found',
                        });
                    } else {
                        this.banks = banks;
                    }

                    this.$emit('loaded');
                })
                .catch((err) => {
                    this.$emit('loaded');
                    this.$swal({
                        type: 'error',
                        title: 'Error banks',
                    });
                });
        },
        loadBranches(bankId) {
          this.$emit('loading');
          FlutterwaveService.getBranchesByBankId(bankId)
              .then((branches) => {
                  this.branches = branches;
                  if (this.branch_code) {
                      this.branch = this.branches.find((item) => item.BranchCode === this.branch_code);
                  }

                  this.$emit('loaded');
              })
              .catch((err) => {
                  this.$swal({
                      type: 'error',
                      title: 'Error loading branches',
                  });

                  this.$emit('loaded');
              })
        },
    },
};
</script>
